import { Entity, EntityType } from '@/modules/pipelines/model/entity';
import { Page } from '@/shared/pagination/export';
import axios from 'axios';

async function getSingleEntity(id: string): Promise<Entity> {
  console.log(`notice pre api ${id}`);
  const res = await axios.get<Entity>(`/api/petro-pipeline/entity/${id}`);
  console.log(`notice api ${JSON.stringify(res, null, 2)}`);
  return res.data;
}

async function getEntities(types?: EntityType[]): Promise<Entity[]> {
  const res = await axios.get<Page<Entity>>(`/api/petro-pipeline/entity`, {
    params: { types },
    paramsSerializer: { indexes: null },
  });
  return res.data.content ?? [];
}

async function getRegionEntities(): Promise<Entity[]> {
  return getEntities([EntityType.REGION]);
}

export interface AssetNode extends Entity {
  active?: boolean;
  assetType?: string;
}

export interface ZoneNode extends Entity {
  assets: AssetNode[];
}

export interface PipelineRegionNode extends Entity {
  zones: ZoneNode[];
}

export type SegmentNode = Entity;

export interface PipelineNode extends Entity {
  segments: SegmentNode[];
  regions: PipelineRegionNode[];
  pipeline?: string;
}

async function getPipelineGraph(): Promise<PipelineNode[]> {
  const res = await axios.get<PipelineNode[]>(`/api/petro-pipeline/entity/pipeline/graph`);
  return res.data ?? [];
}

const api = {
  getSingleEntity,
  getEntities,
  getRegionEntities,
  getPipelineGraph,
};

export default api;
